import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_ACCOUNT_STATUS } from "../../../api/queryKeys";
import { QueryAccountStatusResponse } from "../../../types";

export const getStatusData = () =>
  api
    .get<QueryAccountStatusResponse>(QUERY_ACCOUNT_STATUS)
    .then((res) => res.data);

export default function useGetAccountStatus() {
  return useQuery([QUERY_ACCOUNT_STATUS], getStatusData);
}
